import React from 'react';

// Loader
function Loader() {
  return (
    <div className="loader">
      <div className="roundFull">
        <div className="roundEmpty"></div>
      </div>
    </div>
  );
}

export default Loader;
